export let imagePolicy: string | undefined

export function setImageManagerPolicy(policy: string) {
    imagePolicy = policy
}
